import React from 'react'
import './styles.scss'

const UpsellMain1 = ({ upsell }) => {
	return (
		<div className="upsell-main1">
			<img src={`images/upsell/${upsell}.png`} alt={upsell} />
		</div>
	)
}

export { UpsellMain1 }
